import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ExternalLink, X } from 'lucide-react';

import { mediaUrl } from '@/lib/media';

/** Фото на весь экран. В портале: оболочка чата fixed и двигается за клавиатурой. */
export default function PhotoViewer({ url, onClose }: { url: string; onClose: () => void }) {
  const src = mediaUrl(url);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Фото"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/95"
      onClick={onClose}
    >
      <img src={src} alt="" className="max-h-full max-w-full select-none object-contain" />
      <div className="absolute inset-x-0 top-0 flex justify-end gap-2 p-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="rounded-full bg-white/10 p-2.5 text-white hover:bg-white/20"
          aria-label="Открыть отдельно"
        >
          <ExternalLink size={20} aria-hidden />
        </a>
        <button
          type="button"
          onClick={onClose}
          className="rounded-full bg-white/10 p-2.5 text-white hover:bg-white/20"
          aria-label="Закрыть"
        >
          <X size={20} aria-hidden />
        </button>
      </div>
    </div>,
    document.body,
  );
}
